'use client';

import Text, { TEXT_TAG, TEXT_VARIANT } from '@pixum/text';
import type { CeweAddress } from 'services';
import styles from '../../../CartAddressStep.module.css';

interface AddressCardContentProps {
  address: CeweAddress;
  compareAddress?: CeweAddress;
}

/** Renders the name and postal fields displayed inside a CEWE address card. */
export function AddressCardContent({ address, compareAddress }: AddressCardContentProps) {
  const emphasizeStreet = compareAddress !== undefined && address.street !== compareAddress.street;
  const emphasizeZip = compareAddress !== undefined && address.zip !== compareAddress.zip;
  const emphasizeCity = compareAddress !== undefined && address.city !== compareAddress.city;

  return (
    <div className={styles.cartAddressValidationAddress}>
      <Text tag={TEXT_TAG.SPAN} variant={TEXT_VARIANT.SUBHEADLINE}>
        {address.firstName} {address.lastName}
      </Text>
      <Text tag={TEXT_TAG.SPAN} variant={TEXT_VARIANT.SUBHEADLINE}>
        {emphasizeStreet ? <strong>{address.street}</strong> : address.street}
      </Text>
      <Text tag={TEXT_TAG.SPAN} variant={TEXT_VARIANT.SUBHEADLINE}>
        {emphasizeZip ? <strong>{address.zip}</strong> : address.zip}{' '}
        {emphasizeCity ? <strong>{address.city}</strong> : address.city}
      </Text>
    </div>
  );
}
